import * as types from '../../../../types/masters/department/departmentGroup/departmentGroupTypes';
import * as api from '../../../../../api/masters/department/departmentGroup/departmentGroupApi';

export const fetchDepartmentGroups = () => async (dispatch) => {
  dispatch({ type: types.FETCH_DEPARTMENT_GROUP_REQUEST });
  try {
    const data = await api.fetchDepartmentGroups();
    dispatch({ type: types.FETCH_DEPARTMENT_GROUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_DEPARTMENT_GROUP_FAILURE, payload: error.message });
  }
};

export const addDepartmentGroup = (departmentGroup) => async (dispatch) => {
  try {
    const res = await api.addDepartmentGroup(departmentGroup);
    dispatch({ type: types.ADD_DEPARTMENT_GROUP_SUCCESS, payload: res });
    dispatch(fetchDepartmentGroups());
  } catch (error) {
    dispatch({ type: types.DEPARTMENT_GROUP_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateDepartmentGroup = (id, departmentGroup) => async (dispatch) => {
  try {
    const res = await api.updateDepartmentGroup(id, departmentGroup);
    dispatch({ type: types.UPDATE_DEPARTMENT_GROUP_SUCCESS, payload: res });
    dispatch(fetchDepartmentGroups());
  } catch (error) {
    dispatch({ type: types.DEPARTMENT_GROUP_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteDepartmentGroup = (id) => async (dispatch) => {
  try {
    await api.deleteDepartmentGroup(id);
    dispatch({ type: types.DELETE_DEPARTMENT_GROUP_SUCCESS, payload: id });
    dispatch(fetchDepartmentGroups());
  } catch (error) {
    dispatch({ type: types.DEPARTMENT_GROUP_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setDepartmentGroupEdit = (departmentGroup) => ({
  type: types.SET_DEPARTMENT_GROUP_EDIT,
  payload: departmentGroup,
});

export const clearDepartmentGroupEdit = () => ({
  type: types.CLEAR_DEPARTMENT_GROUP_EDIT,
}); 